export default "__VITE_ASSET__BooSYNp6__"